import React, {useContext} from 'react';

import SelectTitle from "../../../../../components/radioGroup/SelectTitle";
import RadioGroup from "../../../../../components/radioGroup/RadioGroup";
import FormControlLabel from "../../../../../components/radioGroup/FormControlLabel";
import {FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";
import {ListContext} from "../../../../../components/List/context/ListContext";
import {CarrierIconsList} from "../../../../../utils/carrierIconsList";

function CarrierIconField(props) {
    const {values, setFieldValue, setFieldTouched} = useFormikContext();

    return (
        <>
            <SelectTitle
                titleTranslationKey={'shippingMethods.form.field.carrierIcon.label'}
                required={true}
            />
            <RadioGroup
                alignListWithButton
                placeholder={<FormattedMessage id={"shippingMethods.form.field.carrierIcon.label"}/>}
                selectedValueLabel={values.carrierIcon ?
                    <FormattedMessage id={`wms.carrier.name.${values.carrierIcon}`}/> : ""}
                name={'carrierIcon'}
                value={values.carrierIcon}
                onClickAway={() => setFieldTouched('carrierIcon')}
                onChange={(event) => {
                    setFieldValue('carrierIcon', event.currentTarget.value)
                }}
            >
                {CarrierIconsList.toArray().map((carrier, index) => {
                    return (
                        <FormControlLabel
                            key={index}
                            value={carrier}
                            label={<FormattedMessage id={`wms.carrier.name.${carrier}`}/>}
                        />
                    )
                })}
            </RadioGroup>
        </>
    );
}

export default CarrierIconField;
